module.exports = __webpack_public_path__ + "img/everestAsset1.81e81476.png";